import { useApiService } from "medere-ui-framework";
import { QueueNumberDTO } from "../../interface/interface";

export function usePatientCallerService() {
  const { getMethod, postMethod } = useApiService();
  const baseEndpoint = "/api/secured/patientcallercontroller";

  function getActiveQueueNumbers(): Promise<QueueNumberDTO[]> {
    return getMethod<QueueNumberDTO[]>({
      basePath: baseEndpoint,
      endpoint: "/getActiveQueueNumbers"
    });
  }

  function getQueueNumbersSortedByPA(hardwareId: string): Promise<QueueNumberDTO[]> {
    return getMethod<QueueNumberDTO[]>({
      basePath: baseEndpoint,
      endpoint: "/getQueueNumbersSortedByPA",
      params: { hardwareId }
    });
  }

  function getHistoricQueueNumbers(): Promise<QueueNumberDTO[]> {
    return getMethod<QueueNumberDTO[]>({
      basePath: baseEndpoint,
      endpoint: "/getHistoricQueueNumbersOfDay"
    });
  }

  function createQueueNumber(queueStringId: string, associatedPatientId?: number): Promise<QueueNumberDTO> {
    return postMethod<QueueNumberDTO>({
      basePath: "/api/secured/queue",
      endpoint: "/CreateQueueNumbers",
      body: null,
      params: { queueStringId, associatedPatientId }
    });
  }

  function callPatient(dto: QueueNumberDTO, hardwareId: string) {
    return postMethod<QueueNumberDTO>({
      basePath: baseEndpoint,
      endpoint: "/callPatient",
      body: dto,
      params: { hardwareId }
    });
  }

  function deactivateQueueNumber(queueNumberId: number): Promise<void> {
    return postMethod({
      basePath: baseEndpoint,
      endpoint: "/deactivatequeuenumber",
      body: null,
      params: { queueNumberId }
    }).then(() => {});
  }

  return {
    getActiveQueueNumbers,
    getQueueNumbersSortedByPA,
    getHistoricQueueNumbers,
    createQueueNumber,
    callPatient,
    deactivateQueueNumber
  };
}
